import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";
import { FONT_FAMILY } from '../../constants';

export const useStyles = (props) => ({
  chipContainer: css({
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: "border-box",
    padding: '4px 16px',
    marginLeft: 7,
    marginRight: 7,
    borderRadius: 16,
    backgroundColor: props?.defaultBackgroundChip,
    color: Color.neutral[400],
    fontFamily: FONT_FAMILY.ROBOTO_REGULAR,
    fontSize: 12,
    transition: '0.3s all ease',
    userSelect: 'none',
    cursor: 'pointer',
    "&:hover": {
      background: Color.neutral[300],
      color: Color.neutral[0],
      transition: '0.3s all ease'
    }
  }),
  chipContainerActive: css({
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: "border-box",
    padding: '4px 16px',
    marginLeft: 7,
    marginRight: 7,
    borderRadius: 16,
    background: Color.primary[700],
    color: Color.neutral[0],
    fontFamily: FONT_FAMILY.ROBOTO_REGULAR,
    fontSize: 12,
    transition: '0.3s all ease',
    userSelect: 'none',
    cursor: 'pointer',
    "&:hover": {
      background: Color.primary[500],
      color: Color.neutral[0],
      transition: '0.3s all ease'
    }
  }),
  disabled: css({
    border: `1px solid ${Color.neutral[200]} !important`,
    background: `transparent !important`,
    color: `${Color.neutral[300]} !important`,
    cursor: 'auto !important',
    pointerEvents: 'none'
  })
});
